import { FormSpy } from 'react-final-form';
import { memo, useCallback, useState } from 'react';

import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { Button } from 'UIPackage/MainModule/components/Button';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';

import styles from './SubmitedFiles.module.scss';
import { IKnmFormRef } from '../../../../KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from '../../../../DecisionPackage/MainModule/interfaces/IDecisionFormRef';

interface IErknmSubmittedFilesProps {
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  id: string;
  index: number;
  isWatchOnly: boolean;
  name: string;
  sIndex: number;
  isKnm?: boolean;
  isPm?: boolean;
  isDecision?: boolean;
}

export const SubmittedFiles = memo(
  ({ formRef, id, index, isWatchOnly, name, sIndex, isKnm, isPm, isDecision }: IErknmSubmittedFilesProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const handleOpenSignModal = useCallback(() => {
      setIsVisibleSignModal(true);
    }, []);

    const handleCloseSignModal = useCallback(() => {
      setIsVisibleSignModal(false);
    }, []);

    return (
      <Row key={id} margin="medium" isListItem>
        <div className="shared-deleting-row">
          <FieldBlock id={id}>
            <span>Файлы</span>
            {getTitleFieldWithRedStar({
              label: '',
              field: name,
              isDecision,
              isKnm,
              isPm,
            })}
            <Button
              className={styles.AddFileButton}
              text="Добавить"
              type="button"
              variant="link"
              color="primary"
              onClick={handleOpenSignModal}
              disabled={isWatchOnly}
            />
          </FieldBlock>
          <FormSpy subscription={{ errors: true, touched: true }}>
            {props => {
              const fieldError =
                props.errors?.eventsErknm?.[sIndex]?.submittedDocuments?.[index]?.files ||
                props.errors?.events?.[sIndex]?.submittedDocuments?.[index]?.files;

              if (fieldError === REQUIRED_ERROR) {
                return <p className="shared-input-error shared-row__small-margin">Поле не может быть пустым</p>;
              }

              return null;
            }}
          </FormSpy>
          <KnmAttachmentsSigning
            isWatchOnly={isWatchOnly}
            name={name}
            isVisibleSignModal={isVisibleSignModal}
            closeSignModal={handleCloseSignModal}
            formRef={formRef}
          />
        </div>
      </Row>
    );
  },
);
